import React, { useEffect, useState } from "react";
import { FaNewspaper, FaUsers, FaEnvelope, FaInfoCircle } from "react-icons/fa";
import { allAPiServicesCall } from "../../../services/apiServices";
import { getAuthConfig } from "../../../services/apiUtils";
import CommonLayout from "../../../layouts/CommonLayout";
import "./NewsSubscriber.css";

const NewsSubscriber = () => {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const getSubscribers = async (page) => {
    try {
      setLoading(true);
      const response = await allAPiServicesCall.getNewsSubscriber(
        getAuthConfig(),
        page
      );
      setSubscribers(response.data.subscribers);
      setTotalPages(response.data.totalPages);
      setTotalItems(response.data.totalSubscribers);
    } catch (error) {
      console.log("error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSubscribers(currentPage);
  }, [currentPage]);

  return (
    <CommonLayout>
      <div className="subscribers-page">
        {/* Header - Matching Artists Page */}
        <div className="subscribers-header">
          <div className="subscribers-header-top">
            <div className="subscribers-title-wrapper">
              <div className="subscribers-title-icon">
                <FaNewspaper />
              </div>
              <div className="subscribers-title-text">
                <h1 className="subscribers-title">News Subscribers</h1>
                <p className="subscribers-subtitle">Manage your newsletter subscriber list</p>
              </div>
            </div>
            <div className="subscribers-stats">
              <div className="subscribers-stat-badge">
                <FaUsers />
                <span>Total: <strong>{totalItems.toLocaleString()}</strong></span>
              </div>
            </div>
          </div>
        </div>

        {/* Filter Section */}
        <div className="subscribers-filter-section">
          <div className="subscribers-filter-header">
            <div className="subscribers-filter-icon">
              <FaEnvelope />
            </div>
            <h3 className="subscribers-filter-title">All Subscribers</h3>
          </div>
          <div className="subscribers-filter-hint">
            <FaInfoCircle size={12} />
            <span>Browse through all newsletter subscribers</span>
          </div>
        </div>

        {/* Main Card */}
        <div className="subscribers-card">
          {loading ? (
            <div className="subscribers-loading">
              <div className="subscribers-loading-spinner"></div>
              <span className="subscribers-loading-text">Loading subscribers...</span>
            </div>
          ) : subscribers?.length === 0 ? (
            <div className="subscribers-empty">
              <FaUsers className="subscribers-empty-icon" />
              <span className="subscribers-empty-text">No subscribers yet.</span>
              <span className="subscribers-empty-subtitle">When users subscribe to your newsletter, they will appear here.</span>
            </div>
          ) : (
            <>
              {/* Desktop Table View */}
              <div className="subscribers-table-container">
                <table className="subscribers-table">
                  <thead>
                    <tr>
                      <th style={{ width: 80 }}>#</th>
                      <th>Email Address</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subscribers?.map((subscriber, index) => (
                      <tr key={index}>
                        <td>
                          <span className="subscribers-id">
                            {(currentPage - 1) * 10 + index + 1}
                          </span>
                        </td>
                        <td>
                          <div className="subscribers-email-wrapper">
                            <div className="subscribers-email-icon">
                              <FaEnvelope />
                            </div>
                            <span className="subscribers-email">{subscriber?.email}</span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile Card View */}
              <div className="subscribers-mobile-view">
                {subscribers?.map((subscriber, index) => (
                  <div key={index} className="subscribers-mobile-card">
                    <div className="subscribers-mobile-card-header">
                      <div className="subscribers-mobile-card-icon">
                        <FaEnvelope />
                      </div>
                      <div className="subscribers-mobile-card-info">
                        <span className="subscribers-mobile-card-number">
                          #{(currentPage - 1) * 10 + index + 1}
                        </span>
                        <span className="subscribers-mobile-card-email">{subscriber?.email}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {subscribers.length > 0 && (
                <div className="subscribers-pagination">
                  <div className="subscribers-pagination-info">
                    Showing page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                    {totalItems > 0 && (
                      <span> ({totalItems.toLocaleString()} total subscribers)</span>
                    )}
                  </div>
                  <div className="subscribers-pagination-controls">
                    <button
                      className="subscribers-pagination-btn"
                      onClick={handlePreviousPage}
                      disabled={currentPage === 1}
                    >
                      ‹ Prev
                    </button>
                    <span className="subscribers-pagination-current">
                      {currentPage} / {totalPages}
                    </span>
                    <button
                      className="subscribers-pagination-btn"
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                    >
                      Next ›
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </CommonLayout>
  );
};

export default NewsSubscriber;
